import React from 'react';
import { PictoProps } from './index';

export const LikeCircleFilled = (props: PictoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '30'}
    height={props.height || '30'}
    viewBox="0 0 30 30"
    fill="none"
  >
    <circle cx="15" cy="15" r="15" fill="#EFEFEF" />
    <path
      d="M23.0769 13.937C23.0769 16.0616 22.3484 18.9025 22.0156 19.7833C21.8686 20.1757 21.6247 20.5225 21.3097 20.7943C21.0173 21.0516 20.6458 21.1965 20.2565 21.2046C19.4843 21.2046 18.8592 21.2209 18.2744 21.2355C16.1582 21.2893 14.5332 21.33 12.5236 20.6576V11.2523C12.6949 11.0374 12.8564 10.8144 13.0034 10.5832C13.6802 9.4989 14.1051 8.27623 14.2505 7.0031C14.3587 6.17442 14.6446 5.69577 15.0097 5.49714C15.3489 5.31317 15.7205 5.36039 16.0759 5.59646C16.4054 5.83578 16.6752 6.14837 16.8626 6.51142C17.4489 7.56477 17.7769 9.31168 17.1485 11.0879H21.4163C21.5924 11.0879 21.7669 11.1172 21.9316 11.1791C22.3839 11.3516 22.6796 11.7407 22.8556 12.2699C23.0156 12.8104 23.0883 13.372 23.0737 13.937H23.0769ZM11.3396 10.8827H7.31725C7.09917 10.8827 6.9231 11.0618 6.9231 11.2816V21.1411C6.9231 21.3609 7.09917 21.5384 7.31725 21.5384H11.3396C11.5576 21.5384 11.7337 21.3609 11.7337 21.1428V11.2833C11.7337 11.0635 11.5576 10.886 11.3412 10.886L11.3396 10.8827Z"
      fill="#000000"
    />
  </svg>
);
